<mat-toolbar color="primary">
  <mat-toolbar-row>
    <mat-icon class="hoverable" aria-hidden="false" (click)="openSideBar()">menu</mat-icon>
    <div class="img_container" [routerLink]="['/overview']">
      <img src="https://atlas.prometheusdb.at/assets/imgs/mainLogo.png">
    </div>
  </mat-toolbar-row>
</mat-toolbar>